// frontend/src/features/board/components/Feeds/feedCard/HistoryDetails.js
import React from "react";
import Avatar from "../../../../../components/Avatar";
import { createAvatarName, hasImage, SanitizedHtml } from "../../../../../utils";
import arrow from "../../../../../styles/svg/arrow.svg";
import { Tooltip } from "@mui/material";
import { useFeedBoardMeta } from "../hooks/useFeedBoardMeta";

const HistoryDetails = ({ history, boardName }) => {
  const {
    boardKeyDisplay,
    boardName: boardTitle,
    openBoard,
    openCard,
  } = useFeedBoardMeta(boardName, history?.card_id);

  return (
    <div className="w-100">
      <div className="d-flex justify-content-space-between">
        <div className={"d-flex align-items-center"}>
          <div>
            <Tooltip title={boardTitle}>
              <a className="board-anquor cursor-pointer underline" onClick={openBoard}>
                {boardKeyDisplay}
              </a>
            </Tooltip>
            -
            <a
              className="board-anquor cursor-pointer mr-1 underline"
              onClick={openCard}>
              {history?.card_id}:
            </a>
          </div>
          <p className="worklog-title mr-2">
            {history?.response_object?.user_object?.username}
          </p>
        </div>
      </div>
      <div className="d-flex justify-content-space-between">
        <SanitizedHtml
          as="div"
          className="worklog-worklog comment-content"
          html={history?.history_text}
        />
      </div>
      {history?.response_object && (
        <>
          {history?.response_object?.event_type === "card_assign" && (
            <div className="d-flex align-items-center history-heading">
              {history?.response_object?.old_assignee && (
                <>
                  <Avatar
                    user_image={
                      history?.response_object?.old_assignee?.user_image
                    }
                    className={"history-avatar mr-1"}
                    title={history?.response_object?.old_assignee?.username}
                    style={{
                      ...(!hasImage(
                        history?.response_object?.old_assignee?.user_image
                      ) && {
                        bgcolor:
                          history?.response_object?.old_assignee?.profile_color
                            ?.background,
                        color:
                          history?.response_object?.old_assignee?.profile_color
                            ?.background?.text,
                      }),
                    }}>
                    {createAvatarName(
                      history.response_object?.old_assignee?.username
                    )}
                  </Avatar>
                  <p className="mr-4">
                    {history.response_object?.old_assignee?.username}{" "}
                    <img className="ml-4" src={arrow} alt="" />
                  </p>
                </>
              )}
              {history?.response_object?.new_assignee ? (
                <>
                  <Avatar
                    user_image={
                      history?.response_object?.new_assignee?.user_image
                    }
                    className={"history-avatar mr-1"}
                    title={history?.response_object?.new_assignee?.username}
                    style={{
                      ...(!hasImage(
                        history?.response_object?.new_assignee?.user_image
                      ) && {
                        bgcolor:
                          history?.response_object?.new_assignee?.profile_color
                            ?.background,
                        color:
                          history?.response_object?.new_assignee?.profile_color
                            ?.background?.text,
                      }),
                    }}>
                    {createAvatarName(
                      history?.response_object?.new_assignee?.username
                    )}
                  </Avatar>
                  <p>{history?.response_object?.new_assignee?.username}</p>
                </>
              ) : (
                <p>Unassigned</p>
              )}
            </div>
          )}
          {history?.response_object?.event_type === "change_status" && (
            <div className="d-flex align-items-center history-heading">
              <div className="old-status-box">
                <p className="old-status">
                  {history?.response_object?.old_status}
                </p>
              </div>
              <img className="arrow-img" src={arrow} alt="" />
              <div className="new-status-box">
                <p className="new-status">
                  {history?.response_object?.new_status}
                </p>
              </div>
            </div>
          )}
          {history?.response_object?.event_type === "change_board" && (
            <div className="d-flex align-items-center history-heading">
              <div className="old-status-box">
                <p className="old-status">
                  {history?.response_object?.old_board}
                </p>
              </div>
              <img className="arrow-img" src={arrow} alt="" />
              <div className="new-status-box">
                <p className="new-status">
                  {history?.response_object?.new_board}
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default React.memo(HistoryDetails);
